import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
  },
  {
    path: '/setting/work_style',
    name: 'Setting-Workstyle',
    component: () => import('@/views/setting/Workstyle.vue'),
  },
  {
    path: '/setting/users',
    name: 'Setting-Users',
    component: () => import('@/views/setting/Users.vue'),
  },
  {
    path: '/setting/group',
    name: 'Setting-Group',
    component: () => import('@/views/setting/Group.vue'),
  },
  {
    path: '/setting/alert',
    name: 'Setting-Alert',
    component: () => import('@/views/setting/Alert.vue'),
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('@/views/Account.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('@/views/Help.vue'),
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue'),
    // children: [
    //   {
    //     path: 'alert/:alertID',
    //     component: () => import('@/parts/news/AlertModal.vue'),
    //     props: true,
    //   },
    // ],
  },
  {
    path: '/alert/:alertID',
    name: 'Alert',
    component: () => import('@/views/News.vue'),
    props: true,
  },
  {
    path: '/Personal',
    name: 'Personal',
    component: () => import('@/parts/app/disp/Personal.vue'),
  },
  {
    path: '/Signup',
  },
  {
    path: '/Login',
  },
  {
    path: '/new',
  },
  {
    path: '/Invoice',
    name: 'Invoice',
    component: () => import('@/parts/app/disp/Invoice.vue'),
  },
  /*
  { // 追加
    path: '/error',
    name: 'サイトエラー',
    component: () => import('@/views/common/Error.vue'),
  },
  */
  {
    path: '/service/introduction',
    name: 'ServiceIntroduction',
    component: () => import('@/service/Introduction.vue'),
  },
  {
    path: '/service/contact',
    name: 'ServiceContact',
    component: () => import('@/service/Contact.vue'),
  },
  {
    path: '/service/:catchAll(.*)',
    component: () => import('@/parts/app/disp/Welcome.vue'),
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/',
  },
];


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
